export const PntClaims = [
    {
        cod: 1,
        profile: 'master',
        claims: {
            company: "add, update, remove, get, patch",
            companyId: "get",
            providers: "get",
            person: "add, update, remove, get, patch",
            acceptTerms: "add, update, remove, get, patch",
            distributionRules: "add, update, remove, get, patch",
            geographyRegion: "add, update, remove, get, patch",
            inspection: "add, update, remove, get, patch, delete",
            report: "add, update, remove, get, patch",
            surveys: "add, update, remove, get, patch",
            companyPerson: "get",
            dashboard: "add, remove, get",
            dashboardMobi: "add, remove, get",
            providerInspection: "add"
        }
    },
    {
        cod: 5,
        profile: 'intermediario',
        claims: {
            companyId: "get",
            providers: "get",
            person: "get, update, patch",
            inspection: "add, update, remove, get, patch, delete",
            report: "get"
        }
    },
    {
        cod: 8,
        profile: 'prestador_terceirizado_master',
        claims: {
            company: "add, update, remove, get, patch",
            companyId: "get",
            providers: "get",
            person: "add, update, remove, get, patch",
            geographyRegion: "add, update, remove, get, patch",
            inspection: "add update, remove, get, patch",
            report: "add, update, remove, get, patch",
            companyPerson: "add, update, remove, get, patch",
            providerInspection: "add"
        }
    },
    {
        cod: 2,
        profile: 'prestador_terceirizado',
        claims: {
            companyId: "get",
            providers: "get",
            company: "update, get, patch",
            person: "update, get, patch",
            inspection: "add update, remove, get, patch",
            report: "add, update, remove, get, patch",
            providerInspection: "add"
        }
    },
    {
        cod: 4,
        profile: 'prestador_interno',
        claims: {
            companyId: "get",
            providers: "get",
            company: "update, remove, get, patch",
            person: "update, get, patch",
            inspection: "update, remove, get, patch",
            providerInspection: "add",
            report: "add, update, remove, get, patch"
        }
    },
    {
        cod: 7,
        profile: 'pagamentos',
        claims: {
            companyId: "get",
            providers: "get",
            person: "update, get, patch",
            inspection: "get",
            report: "get"
        }
    },
    {
        cod: 6,
        profile: 'basico',
        claims: {
            companyId: "get",
            providers: "get",
            person: "update, get, patch",
            inspection: "get",
            report: "get"
        }
    },
    {
        cod: 16,
        profile: 'mastercliente',
        claims: {
            company: "add, update, remove, get, patch",
            companyId: "add, update, remove, get, patch",
            providers: "add, update, remove, get, patch",
            person: "add, update, remove, get, patch",
            acceptTerms: "add, update, remove, get, patch",
            distributionRules: "add, update, remove, get, patch",
            geographyRegion: "add, update, remove, get, patch",
            inspection: "add, update, remove, get, patch, delete",
            report: "add, update, remove, get, patch",
            surveys: "add, update, remove, get, patch",
            dashboard: "add, remove, get",
            dashboardMobi: "add, remove, get",
            providerInspection: "add"
        }
    },
    {
        cod: 17,
        profile: 'gestorusuarios',
        claims: {
            company: "get",
            person: "add, update, remove, get, patch",
            acceptTerms: "add, update, remove, get, patch",
            inspection: "get",
            providerInspection: "add",
            companyPerson: "add, update, remove, get, patch"
        }
    }
    
];